import defaultValues from '../lib/defaultValues.js'

const state = {
  marketRating: defaultValues.marketRating,
  marketPrice: defaultValues.marketPrice,
  marketAvailability: defaultValues.marketAvailability,
  marketMore: defaultValues.marketMore
}

const getters = {
  getMarketRating: (state) => {
    return state.marketRating
  },
  getMarketPrice: (state) => {
    return state.marketPrice
  },
  getMarketAvailability: (state) => {
    return state.marketAvailability
  },
  getMarketMore: (state) => {
    return state.marketMore
  }
}

const mutations = {
  updateMarketRating: (state, marketRating) => {
    state.marketRating = marketRating
  },
  updateMarketPrice: (state, marketPrice) => {
    state.marketPrice = marketPrice
  },
  updateMarketAvailability: (state, marketAvailability) => {
    state.marketAvailability = marketAvailability
  },
  updateMarketMore: (state, marketMore) => {
    state.marketMore = marketMore
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/marketSearch.js